import { useNavigate } from 'react-router-dom';
import UserRole from '../../../shared/AuthRoles';
import { ContractorRole } from '../../enums/users';

export function useEditProfileNavigation(contractorCompany: boolean) {
    const navigate = useNavigate();
    const loggedInUser = UserRole();

    const pathSegment =
        typeof window !== 'undefined' ? window.location.href.split('/')[3] : '';

    const isOnEditRoute =
        pathSegment === 'editProfile' ||
        pathSegment === 'editContractorProfile';

    const contractorBlocked =
        contractorCompany && loggedInUser?.role !== ContractorRole.Admin;

    const canShowEdit = !isOnEditRoute && !contractorBlocked;

    const navigateToEdit = () => {
        if (contractorCompany) {
            navigate(`/editContractorProfile`, {
                state: { name: 'editContractorProfile' },
            });
        } else {
            navigate(`/profile`, {
                state: { name: 'editProfile' },
            });
        }
    };

    return { canShowEdit, navigateToEdit };
}
